<template>
  <div class="body-wrap">
    <erp-project @node-click="nodeClick"></erp-project>
    <div class="body-main">

      <!-- 搜索 -->
      <div class="search-wrap" >
        <el-input size="mini" placeholder="请选择房产" v-model="houseName" readonly="readonly" style="width: 200px"></el-input>
        <el-input size="mini" placeholder="请输入搜关键字" v-model="keyword" clearable style="width: 200px"></el-input>
        <el-button size="mini" type="primary" @click="getList()" :loading="searchLoading">搜索</el-button>
<!--        <el-button size="mini" type="primary" @click="batchSave()" :loading="searchLoading" :disabled="selectedItemList.length == 0" style="margin-left: 50px" v-if="ERP.isPermission(4001005001)">保存</el-button>-->
<!--        <el-button size="mini" type="danger" @click="batchDelete()" :loading="searchLoading" :disabled="selectedItemList.length == 0" style="margin-left: 0;" v-if="ERP.isPermission(4001005002)">删除</el-button>-->
      </div>

      <!-- 数据列表 -->
      <div class="table-wrap">
        <el-table border v-loading="searchLoading" :data="tableData" @selection-change="handleSelectionChange">
          <el-table-column prop="id" type="selection" align="center" width="50"></el-table-column>
          <el-table-column prop="index" label="No." align="center" width="50"></el-table-column>
          <el-table-column prop="house_name" label="房产名称" align="center"></el-table-column>
          <el-table-column prop="charge_item_name" label="收费项目" align="center"></el-table-column>
          <el-table-column prop="charge_house_name" label="收费标准" align="center"></el-table-column>
          <el-table-column prop="id" label="税率(单位:%)" align="center">
            <template slot-scope="scope">
              <el-input size="mini" v-model="scope.row.tax_rate"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="create_time_formatted" label="税目分类编码" align="center" width="150">
            <template slot-scope="scope">
              <el-input size="mini" v-model="scope.row.goods_tax_no">
                <el-button slot="append" icon="el-icon-search" @click="selectGoodsTaxNo('list', scope.row)" title="点击选择"></el-button>
                <el-button slot="append" icon="el-icon-document-copy" @click="copyGoodsTaxNo(scope.row)" title="复制"></el-button>
              </el-input>
            </template>
          </el-table-column>
          <el-table-column prop="update_admin" label="税目分类编码名称" align="center" width="150">
            <template slot-scope="scope">
              <el-input size="mini" v-model="scope.row.goods_tax_name"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="is_invoice" label="是否开具电子发票" align="center">
            <template slot-scope="scope">
              {{scope.row.is_invoice ? '是' : '否'}}
            </template>
          </el-table-column>
          <el-table-column prop="invoice_type" label="征收方式" align="center">
            <template slot-scope="scope">
              {{getTaxTypeName(scope.row.tax_type)}}
            </template>
          </el-table-column>
          <el-table-column prop="admin_name" label="操作人" align="center"></el-table-column>
          <el-table-column prop="update_time_formatted" label="操作时间" align="center"></el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button type="primary" v-if="ERP.isPermission(4001005001)" size="mini" icon="el-icon-edit" @click="editItem(scope.row)">修改</el-button>
              <el-button type="danger" v-if="scope.row.id > 0 && ERP.isPermission(4001005002)" size="mini" icon="el-icon-edit" @click="deleteItem(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页 -->
      <div class="pagination-wrap">
        <el-pagination background layout="prev, pager, next" :total="total" :page-size="pageSize" :current-page="page" @current-change="pageChange"></el-pagination>
      </div>

      <!-- 选择税目分类编码 -->
      <el-dialog title="选择税目分类编码" :visible.sync="selectDialogVisible" :close-on-click-modal="true" class="business-dialog" width="550px">

        <el-input placeholder="输入关键字进行筛选" prefix-icon="el-icon-search" v-model="goodsTaxNoKeyword" style="margin-bottom: 10px;"></el-input>

        <el-table :data="goodsTaxNoList" stripe border height="400">
          <el-table-column prop="no" label="编码" align="center"></el-table-column>
          <el-table-column prop="name" label="名称" align="center"></el-table-column>
          <el-table-column prop="id" label="操作" align="center" width="120">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="editGoodsTaxNo(scope.row)">选择</el-button>
            </template>
          </el-table-column>
        </el-table>

        <div slot="footer" class="dialog-footer">
          <el-button @click="selectDialogVisible = false">取 消</el-button>
        </div>
      </el-dialog>

      <!-- 修改 -->
      <el-dialog title="修改" :visible.sync="editDialogVisible" :close-on-click-modal="true" class="business-dialog" width="800px">

        <el-form ref="form" :model="form" label-width="150px" size="mini" style="margin-right: 30px;">


          <el-form-item label="房产项目" prop="house_name">
            <el-input v-model="form.house_name" readonly="readonly" class="readonly"></el-input>
          </el-form-item>

          <div class="flex-row">
            <el-form-item label="收费项目" prop="charge_item_name">
              <el-input v-model="form.charge_item_name" readonly="readonly" class="readonly"></el-input>
            </el-form-item>
            <el-form-item label="税率" prop="tax_rate">
              <el-input v-model="form.tax_rate">
                <template slot="append">(单位:%)</template>
              </el-input>
            </el-form-item>
          </div>

          <div class="flex-row">
            <el-form-item label="收费标准" prop="goods_tax_no">
              <el-input size="mini" v-model="form.charge_house_name" readonly="readonly" class="readonly"></el-input>
            </el-form-item>
          </div>

          <div class="flex-row">
            <el-form-item label="税目分类编码	" prop="goods_tax_no">
              <el-input size="mini" v-model="form.goods_tax_no">
                <el-button slot="append" icon="el-icon-search" @click="selectGoodsTaxNo('edit')"></el-button>
              </el-input>
            </el-form-item>
            <el-form-item label="税目分类编码名称" prop="goods_tax_name">
              <el-input v-model="form.goods_tax_name"></el-input>
            </el-form-item>
          </div>

          <div class="flex-row">

            <el-form-item label="是否开具电子发票" prop="is_invoice">
              <el-radio-group v-model="form.is_invoice">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="征收方式" prop="tax_type">
              <el-select v-model="form.tax_type" placeholder="请选择">
                <el-option v-for="item in taxTypeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>

          </div>

          <div class="flex-row">
            <el-form-item label="计算公式">
              <el-select v-model="form.invoice_math_type">
                <el-option label="保障单价" :value="0"></el-option>
                <el-option label="保障数量" :value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="合并开票">
              <el-select v-model="form.is_invoice_merge">
                <el-option label="是" :value="1"></el-option>
                <el-option label="否" :value="0"></el-option>
              </el-select>
            </el-form-item>
          </div>

          <div class="flex-row">

            <el-form-item label="发票类型" prop="invoice_type">
              <el-select v-model="form.invoice_type" placeholder="请选择">
                <el-option v-for="item in invoiceTypeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="发票类型对应税率" prop="invoice_tax_rate">
              <el-input v-model="form.invoice_tax_rate">
                <template slot="append">(单位:%)</template>
              </el-input>
            </el-form-item>

          </div>

          <div class="flex-row">
            <el-form-item label="是否享受优惠政策	" prop="is_preferential_policy">
              <el-radio-group v-model="form.is_preferential_policy">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="优惠政策" prop="preferential_policy">
              <el-select v-model="form.preferential_policy" placeholder="请选择">
                <el-option v-for="item in preferentialPolicyList" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>

          </div>
          <div class="flex-row">
            <el-form-item label="计税编码" prop="calc_tax_code">
              <el-input v-model="form.calc_tax_code"></el-input>
            </el-form-item>
            <el-form-item label="计税方式" prop="calc_tax_type">
              <el-input v-model="form.calc_tax_type"></el-input>
            </el-form-item>
          </div>

        </el-form>

        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="saveItem">保 存</el-button>
          <el-button @click="editDialogVisible = false">取 消</el-button>
        </div>
      </el-dialog>

    </div>
  </div>
</template>
<script>
import ErpProject from "../Common/erp-project";
export default {
  name: 'area-tax',
  components: {ErpProject},
  data () {
    return {
      total: 0,
      tableData: [],
      keyword: '',
      page: 1,
      pageSize: 12,
      houseId: '',
      houseName: '',
      searchLoading: false,
      selectDialogVisible: false,

      goodsTaxNoKeyword: '',
      goodsTaxNoList: [],
      goodsTaxNoData: [],

      selectedItem: '',
      selectedItemList: [],

      editDialogVisible: false,
      taxTypeList: [{label: '正常征收', value: 0}, {label: '简易征收', value: 1}],
      invoiceTypeList: [{"label":"请选择...","value":0},{"label":"收据","value":3},{"label":"中奥收据","value":95},{"label":"资金往来发票","value":2},{"label":"电子发票","value":5},{"label":"定额发票20元","value":9},{"label":"增值税专用发票","value":10},{"label":"服务业通用发票","value":1},{"label":"停车场专用发票","value":4},{"label":"红字发票","value":98},{"label":"增值税普通发票","value":6},{"label":"定额发票5元","value":8},{"label":"系统导入票据","value":101},{"label":"定额发票1元","value":7},{"label":"中奥-收据","value":99}],
      preferentialPolicyList: [{label: '请选择...', value: 0}, {label: '免税', value: 1}, {label: '不含税', value: 2}],
      rules: [],
      form: {}

    }
  },
  mounted() {

  },
  watch: {
    goodsTaxNoKeyword(val) {

      if(val == '') {
        this.goodsTaxNoList = this.goodsTaxNoData
      } else {
        this.goodsTaxNoList = this.goodsTaxNoData.filter(item => {
          return item.no.includes(val) || item.name.includes(val)
        })
      }

    }
  },
  methods: {
    nodeClick(d) {
      this.houseId = d.id
      this.houseName = d.name
      this.getList()
    },

    getFormData(data) {

      let d = {
        id: 0,
        house_id: 0,
        house_name: '',
        charge_item_id: 0,
        charge_item_name: '',
        charge_house_id : 0 ,
        charge_house_name : '',
        tax_rate: 0,
        goods_tax_no: '',
        goods_tax_name: '',
        is_invoice: 1,
        tax_type: 0,
        invoice_type: 0,
        invoice_tax_rate: 0,
        is_preferential_policy: 0,
        preferential_policy: 0,
        calc_tax_code: '',
        calc_tax_type: '',
        invoice_math_type : 0,
        is_invoice_merge : 1,
      }

      if(data) {
        for(let k in data) {
          if(typeof d[k] != 'undefined') d[k] = data[k]
        }
      }

      return d
    },

    getList() {

      this.searchLoading = true
      this.$myhttp.get('admin/getItemTaxHouse', {params: {house_id: this.houseId, page: this.page, page_size: this.pageSize, keyword: this.keyword}}).then(resp => {
        let res = resp.data
        if(res.code == 200) {
          this.tableData = res.data.map((item, index) => {
            return Object.assign({
              index: index + 1,
              tax_rate: 0,
              goods_tax_name: '',
              goods_tax_no: '',
              is_invoice: 1,
              tax_type: 0,
              admin_name: '',
              update_time_formatted: '',
            }, item)
          })
          this.total = res.total
        } else {
          this.tableData = []
          this.total = 0
          this.message(res)
        }
        this.searchLoading = false
      })

    },

    pageChange(data) {
      this.page = data
      this.getList()
    },

    getTaxTypeName(val) {
      for(let k in this.taxTypeList) {
        if(this.taxTypeList[k].value == Number(val)) {
          return this.taxTypeList[k].label
        }
      }
    },

    selectGoodsTaxNo(from, item) {

      if(this.goodsTaxNoData.length == 0) {
        this.getGoodsTaxNoList()
      }

      if(from == 'list') {
        this.selectedItem = item
      } else {
        this.selectedItem = this.form
      }

      this.goodsTaxNoKeyword = ''
      this.selectDialogVisible = true

    },

    copyGoodsTaxNo(item) {
      this.$confirm(`确定要复制吗?`, '提示', {type: 'warning'}).then(() => {

        for(let k in this.tableData) {
          this.tableData[k].goods_tax_name = item.goods_tax_name
          this.tableData[k].goods_tax_no = item.goods_tax_no
        }

      })
    },

    getGoodsTaxNoList() {
      this.$myhttp.get('admin/getGoodsTaxNoList', {params: {page: 1, page_size: 999}}).then(resp => {
        let res = resp.data
        if(res.code == 200) {
          this.goodsTaxNoList = res.data
          this.goodsTaxNoData = res.data
        } else {
          this.goodsTaxNoList = []
          this.goodsTaxNoData = []
        }

      })
    },

    editGoodsTaxNo(item) {
      this.selectedItem.goods_tax_name = item.name
      this.selectedItem.goods_tax_no = item.no
      this.selectDialogVisible = false
    },

    handleSelectionChange(data) {
      this.selectedItemList = data

    },

    batchSave() {

      if(this.selectedItemList.length == 0) {
        this.$message.warning('请先勾选要删除的记录')
        return false
      }

      let data = this.selectedItemList
      this.$myhttp.post('admin/batchSaveItemTaxHouse', {data: data}).then(resp => {
        let res = resp.data
        this.message(res)
        if(res.code == 200) {
          this.getList()
        }
      })

    },

    batchDelete() {

      if(this.selectedItemList.length == 0) {
        this.$message.warning('请先勾选要删除的记录')
        return false
      }

      let ids = []
      this.selectedItemList.forEach(item => {
        if(item.id > 0) ids.push(item.id)
      })

      this.$confirm(`此操作将删除选中记录，是否继续?`, '提示', {type: 'warning'}).then(() => {
        this.deleteAction(ids.join(','))
      })

    },

    editItem(item) {
      let data = this.getFormData(item)
      this.form = Object.assign({}, data)
      this.editDialogVisible = true
    },

    deleteItem(item) {

      this.$confirm(`此操作将删除 [ ${item.charge_item_name} ]，是否继续?`, '提示', {type: 'warning'}).then(() => {
        this.deleteAction(item.id)
      })

    },

    deleteAction(id) {
      this.$myhttp.post('admin/deleteItemTaxHouse', {id: id}).then(res => {
        this.message(res.data)
        if(res.data.code == 200) {
          this.getList()
        }
      })
    },

    saveItem() {

      let data = Object.assign({}, this.form)
      this.$myhttp.post('admin/saveItemTaxHouse', data).then(resp => {
        let res = resp.data
        this.message(res)
        if(res.code == 200) {
          this.editDialogVisible = false
          this.getList()
        }
      })

    },

    message(res) {
      this.$message({type: res.code == 0 ? 'success' : 'error', message: res.msg})
    },


  },

}
</script>
<style lang="scss" scoped>

  @import './common.scss';

  .el-button--small {
    padding: 7px 10px;
  }

  /deep/.el-input-group .el-input-group__append {
    padding: 0 15px;
  }

  /deep/.readonly .el-input__inner {
    background-color: #eee;
  }

  .body-wrap {
    display: flex;

    .body-main {
      flex: 1;
      margin-left: 15px;
    }


  }

</style>



// WEBPACK FOOTER //
// src/components/Admin/Project/AreaTax.vue